import { v4 as uuidv4 } from 'uuid';
/**
 * Generates a new RFC4122 version 4 UUID string.
 *
 * @returns {string} A randomly generated UUID (Universally Unique Identifier).
 *
 * @example
 * const id = uuid();
 * // id = '3b241101-e2bb-4255-8caf-4136c566a962'
 */
export const uuid = (): string => uuidv4();
